<div [formGroup]="formModel.formGroup()">
  <sxw-text-input formControlName="confirmText" placeholder="Type DELETE to confirm" theme="input-theme"></sxw-text-input>
</div>
